import { Link, useLocation } from "react-router-dom";
import { getAuthMode, toAuthUrl } from "utils/authModal";

const AuthLink = ({ mode = "login", type, resetEmail, ...props }) => {
	const location = useLocation();
	return (
		<Link
			tabIndex={0}
			{...props}
			to={toAuthUrl(location, mode, { type, resetEmail })}
			replace={Boolean(getAuthMode(location))}
		/>
	);
};

export default AuthLink;
